module.exports = require('./helpers/bundle-url').getBundleURL('hlUsn') + "logo.7718c6df.svg";